import React, { useContext } from 'react';
import { PublicPasswordContext } from '../context/PublicPasswordContext';
const Footer = () => {
    const context = useContext(PublicPasswordContext);
    return (
        <div>
            <div className="row mt-5">
                <div className="hr-div">
                    <div className="hr"></div>
                </div>
            </div>
            <div className="row mt-3 footer">
                <div className="col-12 text-center">
                    <span className="paragraph-bold-18">{context.organizationData.organizationName}</span><br />
                    <span className="paragraph-regular-14">{context.organizationData.postalAddress}, {context.organizationData.postalZipCodeCity}</span><br />
                    <a href={"mailto:" + context.organizationData.email}>
                        <span className="paragraph-regular-14">{context.organizationData.email}</span>
                    </a>
                </div>
                <div className="ml-3">
                    <span className="paragraph-regular-14">&copy;Zavann</span>
                </div>
            </div>
        </div>
    );
}

export default Footer;